import axios from './axios';
import { apiurl } from '../config/apiUrl';
import { getSapBPNumber } from './formatCrewDisplay';

const mapSearchCrewItem = (item) => ({
  value: item?.uuid,
  crewCode: item?.crewCode || item?.externalId,
  firstName: item?.firstName,
  lastName: item?.lastName,
  rankName: item?.rankName,
  positionName: item?.positionName,
  rankId: item?.rankId,
  rankCategory: item?.rankCategoryName,
  gender: item?.genderName,
  dateOfBirth: item?.dateOfBirth,
  age: item?.age,
  sapBPNumber: getSapBPNumber(item)
});

const findCrewInSearchResults = (items, crewCode) => {
  const code = String(crewCode || '').trim().toLowerCase();
  if (!code) return null;
  return items.find((item) => {
    const itemCode = String(item?.crewCode || item?.externalId || '').trim().toLowerCase();
    return itemCode === code;
  }) || null;
};

export const fetchCrewFromSearch = async ({
  searchCriteria,
  companyId = 0,
  expenseCategoryID = ''
}) => {
  const search = String(searchCriteria || '').trim();
  if (search.length < 4) return null;

  const res = await axios.get(
    `${apiurl?.getPartialSearch}?searchCriteria=${encodeURIComponent(search)}`
    + `&page=1&pageSize=50&expenseCategoryID=${expenseCategoryID}&companyId=${companyId}`
  );
  return res?.data?.items || [];
};

export const enrichCrewWithSapBP = async (crew, { companyId = 0, expenseCategoryID = '' } = {}) => {
  if (!crew?.crewCode || getSapBPNumber(crew)) {
    return crew;
  }

  try {
    const items = await fetchCrewFromSearch({
      searchCriteria: crew.crewCode,
      companyId,
      expenseCategoryID
    });
    let match = findCrewInSearchResults(items, crew.crewCode);

    if (!match && getSapBPNumber({ sapBPNumber: crew.crewCode }) === '') {
      const sapItems = await fetchCrewFromSearch({
        searchCriteria: crew.crewCode.replace(/^#+\s*/, ''),
        companyId,
        expenseCategoryID
      });
      match = findCrewInSearchResults(sapItems, crew.crewCode);
    }

    if (match) {
      const mapped = mapSearchCrewItem(match);
      return {
        ...crew,
        firstName: crew.firstName || mapped.firstName || '',
        lastName: crew.lastName || mapped.lastName || '',
        rankName: crew.rankName || mapped.rankName || '',
        positionName: crew.positionName || mapped.positionName || '',
        sapBPNumber: mapped.sapBPNumber || getSapBPNumber(crew)
      };
    }

    const detailRes = await axios.get(
      `${apiurl?.getCrew}/${encodeURIComponent(crew.crewCode)}`
    );
    const detail = detailRes?.data?.data ?? detailRes?.data;
    if (detail && typeof detail === 'object') {
      return {
        ...crew,
        sapBPNumber: getSapBPNumber(detail) || getSapBPNumber(crew)
      };
    }
  } catch (e) {
    // Keep existing crew row if lookup fails
  }

  return crew;
};

export const enrichCrewListWithSapBP = async (
  crewList = [],
  { companyId = 0, expenseCategoryID = '' } = {}
) => Promise.all(
  crewList.map((crew) => enrichCrewWithSapBP(crew, { companyId, expenseCategoryID }))
);
